import React, { FC, useEffect, useRef, useState } from "react";
import { PaginationHeader } from "../../../../_metronic/partials/pagination/PaginationHeader";
import { PaginationLength } from "../../../../_metronic/partials/pagination/PaginationLength";
import { Paginate } from "../../../../_metronic/partials/pagination/Paginate";
import { PaginateModel } from "../../../models/PaginateModel";
import { useIntl } from "react-intl";
import * as ImportRequestCRUD from "./ImportRequestCRUD";
import queryString from "query-string";
import { useHistory } from "react-router-dom";
import { HeaderModel, ModalModel } from "../../../models/CommonModel";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import {Vietnamese} from "flatpickr/dist/l10n/vn.js"
import { DEFAULT_PER_PAGE } from "../../../constants/common";
import ConfigModal from "../../../components/Modal/ConfigModal";
import RequestTable from "./RequestTable";
import { ImportRequestModel, SearchModel } from "../../../models/ImportRequestModel";
import { AsyncSelect2 } from "../../../../_metronic/partials/select/AsyncSelect2";
import { STORES_ENDPOINT } from "../../../constants/endpoints";
import { formatPrice } from "../../../selectors";

const ImportRequest: FC = () => {

    const initRange:any = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
    const initSearch = {
        page: 1,
        per_page: DEFAULT_PER_PAGE,
        status: '',
        date_type: 'updated_at',
        start_date: initRange[0],
        end_date: initRange[1],
    }
    const intl = useIntl();
    const history = useHistory();
    const searchHistory = history.location.search;
    const fp = useRef<any>(null);
    const [search, setSearch] = useState<SearchModel>(initSearch)
    const [dataPaginate, setDataPaginate] = useState<PaginateModel<ImportRequestModel>>();
    const [subTotal, setSubTotal] = useState<number>(0);
    const [selectedIds, setSelectedIds] = useState<number[]>([])
    const [selectedStore, setSelectedStore] = useState(null);

    const [hideCols, setHideCols] = useState<string[]>([]);
    const [configModal, setConfigModal] = useState<ModalModel>({
        show: false,
        mode: 'add',
    });

    const parseParams = (params: SearchModel) => {
        if (params.page) {
            params.page = +params.page
        }
        if (params.per_page) {
            params.per_page = +params.per_page
        }
        return params
    }


    const initParams: SearchModel = parseParams(queryString.parse(searchHistory))

    useEffect(() => {
        document.title = 'Sento Supplier - Yêu cầu nhập hàng';
    })

    useEffect(() => {
        const params = { ...search, ...initParams}
        getList(params);
        setSearch(params)
    }, [])

    const handlePageLengthChange = (e: any) => {
        getList({ ...search, page: 1, per_page: +e.target.value })
    }

    const handlePageChange = (data: any) => {
        getList({ ...search, page: data.selected + 1 })
    }

    const handleSearch = (e: any) => {
        e.preventDefault();
        getList({ ...search, page: 1 })

    }

    const handleClearSearch = (e: any) => {
        e.preventDefault();
        if (fp.current?.flatpickr) {
            fp.current.flatpickr.clear();
        }
        setSearch({
            ...initSearch,
        });
        setSelectedStore(null)
        getList({ ...initSearch })
    }

    const getList = async (params: SearchModel) => {
        let searchQ = {...params};
        if (searchQ?.start_date && searchQ.end_date) {
            searchQ = {...searchQ, date: {startDate: searchQ.start_date, endDate: searchQ.end_date}}
        }
        const {data: resData} = await ImportRequestCRUD.getList(searchQ);
        const objQuery = { ...params }
        if (objQuery.page === 1) {
            delete objQuery.page
        }
        if (objQuery.per_page === DEFAULT_PER_PAGE) {
            delete objQuery.per_page
        }
        history.push({ search: `?${queryString.stringify(objQuery)}` })
        if (fp.current && fp.current.flatpickr) {
            fp.current.flatpickr.setDate([moment(params.start_date).toDate(), moment(params.end_date).toDate()]);
        }
        setDataPaginate(resData?.paginate_data);
        setSubTotal(resData?.sum_total ?? 0);
        setSearch(params ?? {});
    }

    const header: HeaderModel[] = [
        {
            label: intl.formatMessage({ id: 'WAREHOUSE.RECEIPT_CODE' }),
            style: { minWidth: "150px" },
            field: 'code',
            sortable: true
        },
        {
            label: 'Cửa hàng',
            style: { minWidth: "150px" },
            field: 'store',
            sortable: false
        },
        {
            label: intl.formatMessage({ id: 'WAREHOUSE.STATUS' }),
            style: { minWidth: "150px" },
            field: 'status',
            sortable: true
        },
        {
            label: 'Ngày tạo',
            style: { minWidth: "150px" },
            field: 'created_at',
            sortable: true
        },
        {
            label: 'Ghi chú',
            style: { minWidth: "200px" },
            field: 'supplier_note',
            sortable: true
        }
    ]

    const handleSort = (sortBy: string, direction: 'asc' | 'desc' | 'none') => {
        const currentSearch = { ...search };
        const sortParams: SearchModel = { ...currentSearch, sort_by: sortBy, sort_direction: direction };
        if (direction === 'none') {
            delete sortParams.sort_by;
            delete sortParams.sort_direction;
        }
        getList({ ...sortParams });
    }

    const handleChangeVisCols = (e: any) => {
        let hiddenCols = [...hideCols];
        if (!e.target?.checked) {
            setHideCols([...hiddenCols, e.target.name])
        } else {
            setHideCols(hiddenCols.filter((item) => item !== e.target.name))
        }
    }

    return <div className="card">
        <div className="card-header py-4">
            <div className="col-md-12">
                <form onSubmit={handleSearch}>
                    <div className="row">
                        <div className='col-md-3 mb-2'>
                            <label className='form-label'>Cửa hàng</label>
                            <AsyncSelect2
                                sourceUrl={`${STORES_ENDPOINT}`}
                                defaultOptions
                                default
                                name='store_id'
                                value={selectedStore}
                                onChange={(selectedOption: any) => {
                                    setSearch({ ...search, store_id: selectedOption ? selectedOption.value : ''})
                                    setSelectedStore(selectedOption);
                                }}
                            />
                        </div>
                        <div className="col-md-3 mb-2">
                            <label className="form-label">{intl.formatMessage({id: 'ORDER.STATUS'})}</label>
                            <select
                                className="form-select"
                                value={search.status}
                                onChange={(e) => setSearch({...search, status: e.target.value})}
                                name="status"
                            >
                                <option value="">Tất cả</option>
                                <option value="draft">Nháp</option>
                                <option value="new">Mới</option>
                                <option value="preparing">Đang chuẩn bị hàng</option>
                                <option value="shipping">Đang giao hàng</option>
                                <option value="done">Đã hoàn thành</option>
                                <option value="is_incorrect">Cần đối soát</option>
                                <option value="canceled">Đã hủy</option>
                            </select>
                        </div>
                        <div className="col-md-3 mb-2">
                            <label className="form-label">Loại ngày</label>
                            <select
                                className="form-select"
                                value={search.date_type}
                                onChange={(e) => setSearch({...search, date_type: e.target.value})}
                                name="date_type"
                            >
                                <option value="">Tất cả</option>
                                <option value="created_at">Ngày tạo</option>
                                <option value="updated_at">Ngày cập nhật</option>
                            </select>
                        </div>
                        <div className='col-md-3 mb-2'>
                            <label className="form-label">{intl.formatMessage({ id: 'COMMON.TIME' })}</label>
                            <Flatpickr
                                ref={fp}
                                onChange={(date) => {
                                    let startDate = moment(date[0]).format('YYYY-MM-DD');
                                    let endDate = moment(date[1]).format('YYYY-MM-DD');
                                    setSearch({ ...search, start_date: startDate, end_date: endDate });
                                }}
                                options={{
                                    mode: "range",
                                    dateFormat: 'd-m-Y',
                                    enableTime: false,
                                    locale: Vietnamese,
                                    defaultDate: [moment().format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')],
                                }}
                                className='form-control'
                                placeholder=''
                            />
                        </div>
                        <div className="row btns-group">
                            <button
                                className="col-auto btn btn-primary mt-8 me-2"
                                onClick={handleSearch}
                            >
                                <i className="bi bi bi-search fs-4"></i> {intl.formatMessage({ id: 'COMMON.SEARCH' })}
                            </button>
                            <button
                                className="col-auto btn btn-danger mt-8 me-2"
                                type="button"
                                onClick={handleClearSearch}
                            >
                                <i className="bi bi-eraser-fill fs-1"></i> Re-search
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div className="card-body">
            <div className="justify-content-between align-items-center my-3 row">
                <div className='col-12'>
                    <PaginationHeader from={dataPaginate?.meta?.from || 0} to={dataPaginate?.meta?.to || 0}
                        total={dataPaginate?.meta?.total || 0} />
                </div>
                <div className='col-12 col-md-4'>
                    <h3>Tổng giá trị: <span className="text-bold">{formatPrice(subTotal)} VNĐ</span></h3>
                </div>
            </div>
            <RequestTable
                selectedIds={selectedIds}
                data={dataPaginate?.data || []}
                openColConfig={() => setConfigModal({ ...configModal, show: true })}
                header={header}
                hideCols={hideCols}
                handleSort={handleSort}
                setSelectedIds={(ids) => setSelectedIds(ids)}
            />
        </div>
        <div className="card-footer d-flex justify-content-between paginate-wrapper">
            <PaginationLength selected={search.per_page || DEFAULT_PER_PAGE} onChange={handlePageLengthChange} />
            <Paginate
                pageCount={dataPaginate?.meta?.last_page || 0}
                onPageChange={handlePageChange}
                forcePage={(search.page || 1) - 1}
            />
        </div>
        <ConfigModal
            {...configModal}
            header={header}
            hideCols={hideCols}
            handleChangeVisCols={handleChangeVisCols}
            onClose={() => { setConfigModal({ ...configModal, show: false }) }}
        />
    </div>
}
export default ImportRequest;